// extracted by mini-css-extract-plugin
export default {"darkLogo":"Logo_darkLogo__IqQ4X","lightLogo":"Logo_lightLogo__A9sck"};